<mat-card appearance="outlined" class="custom-selection-card border-0 shadow-sm">
  
  <mat-card-header class="p-3 bg-white border-bottom d-flex flex-column gap-2">
    <mat-form-field appearance="outline" class="w-100 search-field-clean">
      <mat-label>Recherche</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Entrez votre recherche" #input [formControl]="searchControl">
      <mat-icon matPrefix class="text-muted">search</mat-icon>
      
      @if (input.value !== '') {
        <button mat-icon-button matSuffix color="accent" (click)="resetInput($event)" aria-label="Effacer la recherche">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    @if (multi && !input.value) {
      <div class="px-1 pt-1">
        <mat-checkbox #check  (click)="setAllValues(check.checked); $event.stopPropagation()" matTooltip="Tout sélectionner">
          <span class="text-secondary small fw-medium">Sélectionner tout</span>
        </mat-checkbox>
      </div>
    }
  </mat-card-header>

  <mat-card-content class="position-relative p-0 bg-white list-scroll-container">
    @if(multi) {
    <mat-selection-list #matSelect class="custom-list-style" (selectionChange)="onSelectionChange($event)">
      @for (item of dataSource.filteredData; track item.id) {
        <mat-list-option [value]="item"
                        [hidden]="item.hide"
                        [disabled]="item.disabled"
                        [selected]="isSelected(item)"
                        class="list-item-hover">
          <span class="text-dark fw-medium small">{{ item.name }}</span>
        </mat-list-option>
        <mat-divider></mat-divider>
      } @empty {
        <div class="p-4">
          @if (input.value) {
            <div class="alert alert-custom-info text-center small m-0" role="alert">
              Aucun élément ne correspond à <strong>"{{ searchControl.value }}"</strong>
            </div>
          } @else {
            <div class="alert alert-custom-info text-center small m-0" role="alert">
              La liste est vide
            </div>
          }
        </div>
      }
    </mat-selection-list>
    } @else {
      <mat-action-list class="custom-list-style">
        @for (item of dataSource.filteredData; track item) {
          <button mat-list-item (click)="setValue(item)" class="list-item-hover">
            <span class="text-dark fw-medium small" matListItemTitle>{{ item.name }}</span>
          </button>
          <mat-divider></mat-divider>
        } @empty {
          <div class="p-4">
            @if (input.value) {
              <div class="alert alert-custom-info text-center small m-0" role="alert">
                Aucun élément ne correspond à <strong>"{{ searchControl.value }}"</strong>
              </div>
            } @else {
              <div class="alert alert-custom-info text-center small m-0" role="alert">
                La liste est vide
              </div>
            }
          </div>
        }
      </mat-action-list>
    }
  </mat-card-content>

  <mat-card-footer class="border-top bg-light px-3 py-2 d-flex justify-content-between align-items-center">
    <span class="text-muted small fw-medium">Éléments affichés</span>
    <span class="badge-count-total">{{ dataSource.filteredData.length }} / {{ dataSource.data.length }}</span>
  </mat-card-footer>
</mat-card>
